// @flow

import {
  SHOW_CONTACT_FORM,
  SET_PLACES,
  SET_CURRENT_PLACE,
  SET_CATEGORIES,
  SET_CURRENT_CATEGORY_ID,
  SET_HOVERED_STUDIO_INTERNAL_NAME,
  SET_BRANDS,
} from './actions';
import type { PlaceType, CategoryType, BrandType } from '../api/types';

type ShowContactFormType = { type: SHOW_CONTACT_FORM, payload: boolean };
type SetPlacesType = { type: SET_PLACES, payload: Array<PlaceType> };
type SetCurrentPlaceType = { type: SET_CURRENT_PLACE, payload: PlaceType };
type SetCategoriesType = { type: SET_CATEGORIES, payload: Array<CategoryType> };
type SetBrandsType = { type: SET_BRANDS, payload: Array<BrandType> };
type SetCurrentCategoryIdType = { type: SET_CURRENT_CATEGORY_ID, payload: ?number };
type SetHoveredStudioInternalName = { type: SET_HOVERED_STUDIO_INTERNAL_NAME, payload: string };

export type ActionType =
  | ShowContactFormType
  | SetPlacesType
  | SetCurrentPlaceType
  | SetCategoriesType
  | SetCurrentCategoryIdType
  | SetBrandsType
  | SetHoveredStudioInternalName;

export function setContactFormShowStatus(status: boolean) {
  return { type: SHOW_CONTACT_FORM, payload: status };
}

export function setPlaces(places: Array<PlaceType>) {
  return { type: SET_PLACES, payload: places };
}

export function setCurrentPlace(currentPlace: PlaceType) {
  return { type: SET_CURRENT_PLACE, payload: currentPlace };
}

export function setCategories(categories: Array<CategoryType>) {
  return { type: SET_CATEGORIES, payload: categories };
}

export function setCurrentCategoryId(id: ?number = null) {
  return { type: SET_CURRENT_CATEGORY_ID, payload: id };
}

export function setHoveredStudioInternalName(internalName: string) {
  return { type: SET_HOVERED_STUDIO_INTERNAL_NAME, payload: internalName };
}

export function setBrands(brands: Array<BrandType>) {
  return { type: SET_BRANDS, payload: brands };
}



// WEBPACK FOOTER //
// ./src/redux/actionsCreators.js